/*
 * TGB - currency conversion for merchant-entered amounts.
 *
 * snippets/tgb-price-tokens.liquid renders fixed amounts (the [next-price]
 * metafield and [money:NNN] tokens) as <span data-tgb-money="<cents in shop
 * currency>">fallback</span>. Liquid cannot convert to the visitor's currency,
 * so this does it with the rate Shopify exposes on every storefront
 * (window.Shopify.currency = { active: 'EUR', rate: '0.92' }, relative to the
 * shop currency). Variant prices ([price], [compare-at]) are converted by
 * Shopify itself and never pass through here.
 *
 * Idempotent: the snippet emits this tag next to every use, so the file must
 * survive being included many times on one page. window.tgbMoney.format(root)
 * is exposed for scripts that inject tokenised markup later (the countdown).
 */
(function () {
  'use strict';
  if (window.tgbMoney) { return; }

  function formatter() {
    var cur = window.Shopify && window.Shopify.currency;
    if (!cur || !cur.active) { return null; }
    var rate = parseFloat(cur.rate) || 1;
    var lang = document.documentElement.lang || 'en';
    var nf;
    try {
      nf = new Intl.NumberFormat(lang, { style: 'currency', currency: cur.active, minimumFractionDigits: 0, maximumFractionDigits: 2 });
    } catch (e) { return null; }
    return function (cents) { return nf.format((cents / 100) * rate); };
  }

  function format(root) {
    var fmt = formatter();
    if (!fmt) { return; }
    (root || document).querySelectorAll('[data-tgb-money]').forEach(function (el) {
      if (el.getAttribute('data-tgb-money-done')) { return; }
      var cents = parseInt(el.getAttribute('data-tgb-money'), 10);
      if (isNaN(cents)) { return; }
      el.textContent = fmt(cents);
      el.setAttribute('data-tgb-money-done', '1');
    });
  }

  window.tgbMoney = { format: format };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { format(document); });
  } else {
    format(document);
  }
  document.addEventListener('shopify:section:load', function (e) { format(e.target); });
})();
